var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCancelSuccess = function SvgCancelSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 88c22.091 0 40-17.909 40-40S70.091 8 48 8 8 25.909 8 48s17.909 40 40 40Z",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.65 64.667 25.777 48.672l4.476-4.51L41.65 55.613l24.096-24.28 4.476 4.542L41.65 64.667Z",
    fill: "#000"
  })));
};
export { SvgCancelSuccess as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHZpZXdCb3g9IjAgMCA5NiA5NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik00OCA4OEM3MC4wOTE0IDg4IDg4IDcwLjA5MSA4OCA0OEM4OCAyNS45MDg2IDcwLjA5MTQgOCA0OCA4QzI1LjkwODYgOCA4IDI1LjkwODYgOCA0OEM4IDcwLjA5MSAyNS45MDg2IDg4IDQ4IDg4WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNNDEuNjUwMyA2NC42NjdMMjUuNzc3MyA0OC42NzE3TDMwLjI1MzUgNDQuMTYxMUw0MS42NTAzIDU1LjYxMzVMNjUuNzQ1NiAzMS4zMzMzTDcwLjIyMTggMzUuODc1OEw0MS42NTAzIDY0LjY2N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";